import React from "react";
import "./Menu.scss";
import { Grid, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";

export function Menu() {
  return (
    <div className="footer-block text-centered">
      <h4>© Sergio Mercado (Draquio)</h4>
    </div>
  );
}
